<!--
Transition coutesy of: https://stackoverflow.com/a/55137929

Recommended:
  cloak.css

Button Example:

<button @click="$refs['mobile-menu'].toggle()" class="flex items-center px-3 py-2 border rounded text-violet border-violet focus:outline-none hover:text-opacity-75 hover:opacity-75">
    <svg class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
  </svg>
</button>

Menu Example:

<reveal-menu ref="mobile-menu" class="mt-8" v-cloak>
  {{ partial:statamic/layouts/navbar mobile="true"}}
</reveal-menu>

components.js

-->

<template>
  <div>
    <transition
        enter-active-class="enter-active"
        leave-active-class="leave-active"
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
        @after-leave="afterLeave">
      <div v-show="open">
        <slot name="default"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "MobileMenu",
  data() {
    return {
      open: false
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    /**
     * @param {HTMLElement} element
     */
    beforeEnter(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = '0px';
        }
        element.style.display = null;
      });
    },
    /**
     * @param {HTMLElement} element
     */
    enter(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = `${element.scrollHeight}px`;
        });
      });
    },
    /**
     * @param {HTMLElement} element
     */
    afterEnter(element) {
      element.style.height = null;
    },
    /**
     * @param {HTMLElement} element
     */
    beforeLeave(element) {
      requestAnimationFrame(() => {
        if (!element.style.height) {
          element.style.height = `${element.offsetHeight}px`;
        }
      });
    },
    /**
     * @param {HTMLElement} element
     */
    leave(element) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          element.style.height = '0px';
        });
      });
    },
    /**
     * @param {HTMLElement} element
     */
    afterLeave(element) {
      element.style.height = null;
    },
  }
}
</script>
<style scoped>
.enter-active,
.leave-active {
  overflow: hidden;
  transition: height .2s linear;
}
</style>